import React from 'react';
import { commonStyles, css, StyleSheet } from '../../Common/styling';
import { RadioButtonChecked as CallMadeIcon } from '@mui/icons-material';
import { Fab } from '@mui/material';

const styles = StyleSheet.create({
  callMadeIcon: {
    position: 'relative',
    bottom: '1px',
    paddingRight: '10px',
    verticalAlign: 'middle',
    color: '#fee721',
  },
});

type Props = {
  onClick: any;
  text: string;
};

const CallInterviewFab: React.FC<Props> = (props) => {
  return (
    <Fab
      variant="extended"
      color="inherit"
      aria-label="CallInterview"
      className={css(commonStyles.selectionFabStyle2)}
      onClick={props.onClick}
    >
      <CallMadeIcon className={css(styles.callMadeIcon)} />
      {props.text}
    </Fab>
  );
};

export default CallInterviewFab;
